import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import ConceptHero from './components/ConceptHero';
import ConceptBody from './components/ConceptBody';
import HomeFooter from '@/pages/home/components/HomeFooter';

export default function CampaignConcept() {
  useScrollAnimation();
  return (
    <main className="bg-black min-h-screen">
      <ConceptHero />
      <ConceptBody />

      {/* Triptych Visual Section */}
      <section className="bg-black py-28 px-6 md:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="fade-in-up text-center mb-16">
            <p className="text-[#4D1815] text-xs tracking-widest mb-4" style={{ letterSpacing: '0.5em', fontFamily: "'Cormorant Garamond', serif" }}>— CAMPAIGN VISUALS —</p>
            <h2 className="text-[#EADDCC] font-light" style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 'clamp(28px, 4vw, 52px)', letterSpacing: '0.1em' }}>The Triptych</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {[
              {
                image: 'https://static.readdy.ai/image/79bbd12133c9c5c423ad9964f66c8be6/d1d2e04dc6e10e22d7db0b1c0eaaaf30.jpeg',
                label: 'I. INSTINCT vs CONTROL',
                sub: 'Instinct is suppressed, creating tension beneath the surface.',
              },
              {
                image: 'https://static.readdy.ai/image/79bbd12133c9c5c423ad9964f66c8be6/aceacdeb6e121e37c14f534ad3abc068.jpeg',
                label: 'II. COEXISTENCE',
                sub: 'Instinct and elegance collide in a moment of raw expression.',
              },
              {
                image: 'https://static.readdy.ai/image/79bbd12133c9c5c423ad9964f66c8be6/ffcfc912b36ae579c1fffbc916ea7a8f.jpeg',
                label: 'III. REFINED BEAUTY',
                sub: 'Beauty appears controlled, while instinct subtly persists beneath it.',
              },
            ].map((item, i) => (
              <div key={i} className="fade-in-up hover-zoom group relative overflow-hidden" style={{ height: '600px' }}>
                <img
                  src={item.image}
                  alt={item.label}
                  className="w-full h-full object-cover object-center"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-transparent to-transparent" />
                <div className="absolute bottom-8 left-8">
                  <p className="text-[#EADDCC] text-lg font-light" style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: '0.15em' }}>{item.label}</p>
                  <p className="text-[#EADDCC]/50 text-xs italic mt-1" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{item.sub}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <HomeFooter />
    </main>
  );
}
